import React from "react";
import styles from "./styles.module.css";
import { InputProps } from "../types";
import TextField from "@material-ui/core/TextField";

export const TextInput1 = ({
  error,
  placeholder,
  disabled,
  type,
  autoFocus,
  value = "",
  onChange
}: InputProps) => (
  <TextField
    className={styles.component}
    {...{
      label: placeholder,
      error: error !== undefined,
      disabled,
      type,
      autoFocus,
      value,
      onChange: evt => onChange && onChange(evt.target.value)
    }}
  />
);
